<template>
	<Popup
		v-model="selfDisplay"
		title="查看商品"
		:confirmBtnDisplay="false"
	>
		<div style="padding: 15px;">
			<div class="base_form_row">
				<span class="b_label"><span style="color: #f00;">*</span>商品名称</span>
				<el-input :value="name" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>商品描述</span>
				<el-input :value="desc" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>商品原价</span>
				<el-input :value="oldPrice" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>商品折扣价</span>
				<el-input :value="price" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>是否虚拟产品</span>
				<div class="b_checkbox_group">
					<el-radio-group :value="isVirtual" disabled>
						<el-radio :label="1">是</el-radio>
						<el-radio :label="2">否</el-radio>
					</el-radio-group>
				</div>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>天数</span>
				<el-input :value="days" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>次数</span>
				<el-input :value="times" disabled></el-input>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>训练产品列表</span>
				<el-select :value="trainingProduct" disabled style="width: 100%;">
					<el-option v-for="v in appTrainingProduct" :key="v.id" :value="v.id" :label="v.name"></el-option>
				</el-select>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>关联疾病</span>
				<div class="b_checkbox_group">
					<el-checkbox-group :value="disease" disabled>
						<el-checkbox v-for="v in diseaseList" :key="v.id" :label="v.id">{{ v.name }}</el-checkbox>
					</el-checkbox-group>
				</div>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>列表图</span>
				<div class="b_upload b_inline_block" style="border: 1px solid #ccc;">
					<img :src="post" alt="" style="">
				</div>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>卡片图</span>
				<div class="b_upload b_inline_block" style="border: 1px solid #ccc;">
					<img :src="cardImg" alt="" style="">
				</div>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>轮播图</span>
				<div v-if="carousels.length">
					<div v-for="(v, i) in carousels" :key="i" class="b_upload b_inline_block" style="margin: 0 20px 20px 0;border: 1px solid #ccc;">
						<img :src="carousels[i]" alt="" style="">
					</div>
				</div>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>信息图</span>
				<div v-if="infoPic.length">
					<div v-for="(v, i) in infoPic" :key="i" class="b_upload b_inline_block" style="margin: 0 20px 20px 0;border: 1px solid #ccc;">
						<img :src="infoPic[i]" alt="" style="">
					</div>
				</div>
			</div>
			
			<div class="base_form_row" style="margin-top: 20px;">
				<span class="b_label"><span style="color: #f00;">*</span>运费</span>
				<el-input :value="fare" disabled></el-input>
			</div>
		</div>
	</Popup>
</template>

<script>
	import { mapState } from 'vuex';
	
	export default {
		model: {
			prop: 'display',
			event: 'changeDisplay'
		},
		props: {
			display: Boolean,
			obj: {
				type: Object,
				default() { return {}; }
			},
			diseaseList: {
				type: Array,
				default() { return []; }
			}
		},
		mounted () {
			this.display && (this.selfDisplay = true);
		},
		data () {
			return {
				selfDisplay: false,
				
				name: '',
				desc: '',
				oldPrice: '',
				price: '',
				isVirtual: 1,
				days: '',
				times: '',
				trainingProduct: '',
				disease: [],
				post: '',
				cardImg: '',
				carousels: [],
				infoPic: [],
				fare: ''
			}
		},
		computed: {
			...mapState([
				'appTrainingProduct'
			])
		},
		methods: {
		
		},
		watch: {
			display(newVal) {
				this.selfDisplay = newVal;
			},
			selfDisplay(newVal) {
				this.$emit("changeDisplay", newVal);
				if (newVal) {
					this.name = this.obj.name;
					this.desc = this.obj.desc;
					this.oldPrice = this.obj.oldPrice;
					this.price = this.obj.price;
					this.isVirtual = this.obj.isVirtual;
					this.days = this.obj.days;
					this.times = this.obj.times;
					this.trainingProduct = this.obj.trainingProduct;
					this.disease = this.obj.diseaseIds;
					this.post = this.obj.post;
					this.cardImg = this.obj.cardImg;
					this.carousels = this.obj.carousels;
					this.infoPic = this.obj.infoPic;
					this.fare = this.obj.fare;
				}
			}
		}
	}
</script>

<style>
</style>
